export const breadcrumbsConfig = {
  pl: {
    home: 'Strona główna',
    homepage: 'Strona główna',
    services: 'Usługi',
    diseases: 'Choroby',
    team: 'Zespół',
    blog: 'Blog',
    aboutUs: 'O nas',
    recruitment: 'Rekrutacja',
    contact: 'Kontakt',
    therapy: 'Terapia',
    // URLs for breadcrumb links
    servicesUrl: '/uslugi/',
    diseasesUrl: '/choroby/',
    teamUrl: '/zespol/',
    blogUrl: '/blog/',
    aboutUsUrl: '/o-nas/',
    recruitmentUrl: '/rekrutacja/',
    contactUrl: '/kontakt/',
    therapyUrl: '/terapia/',
  },
  en: {
    home: 'Home',
    homepage: 'Home',
    services: 'Services',
    diseases: 'Diseases',
    team: 'Team',
    blog: 'Blog',
    aboutUs: 'About Us',
    recruitment: 'Recruitment',
    contact: 'Contact',
    therapy: 'Therapy',
    // URLs for breadcrumb links
    servicesUrl: '/services/',
    diseasesUrl: '/diseases/',
    teamUrl: '/team/',
    blogUrl: '/blog/',
    aboutUsUrl: '/about-us/',
    recruitmentUrl: '/recruitment/',
    contactUrl: '/contact/',
    therapyUrl: '/therapy/',
  },
};

export const getBreadcrumbTranslation = (key: string, locale = 'pl'): string => {
  return breadcrumbsConfig[locale]?.[key] || breadcrumbsConfig.pl[key] || key;
};
